// extracted by mini-css-extract-plugin
export var sizeH1 = "FontSizes-module--size-h1--fe2ea";
export var sizeH2 = "FontSizes-module--size-h2--d907b";
export var sizeH3 = "FontSizes-module--size-h3--ee448";
export var sizeH4 = "FontSizes-module--size-h4--5a62a";
export var sizeH5 = "FontSizes-module--size-h5--a32cc";
export var sizeH6 = "FontSizes-module--size-h6--79194";
export var sizeP = "FontSizes-module--size-p--b6a0a";
export var sizeSm = "FontSizes-module--size-sm--c35df";